export const waitingRoomCategory = [
  {
    reason: "Direct Transfer",
    defaultPriority: 1,
    description: "Any call that is Direct transferred / warm transferred to a nurse, regardless of group"
  },
  {
    reason: "Urgent Symptom",
    defaultPriority: 1,
    description: "Priority symptom that is not a Direct Transfer."
  },
  {
    reason: "Special Handling",
    defaultPriority: 2,
    description: "Non-Urgent symptom, escalated due to other circumstances such as age, translation call, international call, etc."
  },
  {
    reason: "Non-Urgent Symptom",
    defaultPriority: 3,
    description: "Non urgent symptom"
  },
  {
    reason: "Information Only",
    defaultPriority: 4,
    description: "Non symptom call. Requesting information only"
  },
  {
    reason: "HCN Encounter",
    defaultPriority: 4,
    description: "Non-clinical encounters that can be processed by an HCN (Navigator)."
  }
];
